import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
const standards = [{
  title: 'Okna a balkony',
  items: [{
    label: 'Plastová okna',
    value: 'FenStar Energy, věrná imitace hliníkových oken'
  }, {
    label: 'Zasklení',
    value: 'Izolační trojsklo (ve standardu)'
  }, {
    label: 'Tepelná izolace',
    value: 'Uw až 0,74 W/m²K'
  }, {
    label: 'Balkonové dveře',
    value: 'Terasové dveře FenStar, posuvné/otevíravé'
  }]
}, {
  title: 'Podlahy',
  items: [{
    label: 'Obytné místnosti',
    value: 'Princ Parket — Dub Robust 15×195, třívrstvá dřevěná'
  }, {
    label: 'Povrch',
    value: 'Natur olejovaný, kartáčovaný'
  }, {
    label: 'Terasa / Lodžie',
    value: 'MB Keramika — Terrazzo Grigio, 60×60'
  }]
}, {
  title: 'Dveře',
  items: [{
    label: 'Vstupní dveře',
    value: 'SEPOS — Bezpečnostní RC2, protipožární EI/EW 30'
  }, {
    label: 'Interiérové dveře',
    value: 'SEPOS — Otočné, CPL bílá, výška 197 cm'
  }, {
    label: 'Kování',
    value: 'Rostex, černá mat (český výrobce)'
  }]
}, {
  title: 'Koupelny a WC',
  items: [{
    label: 'WC',
    value: 'Závěsné, Rimless technologie (Geberit Duofix)'
  }, {
    label: 'Umyvadlo',
    value: 'Keramické na skříňce, stojánková baterie chrom'
  }, {
    label: 'Sprchový kout',
    value: 'Walk-in, nerezový žlab, termostatická baterie černá mat'
  }, {
    label: 'Obklady',
    value: 'Navarti Blancos bílá lesk (30×60 cm)'
  }, {
    label: 'Dlažba',
    value: 'Atlas Concorde Boost Mix Ivory (60×60 cm)'
  }]
}, {
  title: 'Technologie',
  items: [{
    label: 'Vytápění',
    value: 'Nízkoteplotní podlahové (elektrokotel se zásobníkem 120l)'
  }, {
    label: 'Klimatizace',
    value: 'Příprava pro 2 jednotky (obývák, ložnice)'
  }, {
    label: 'Stínění',
    value: 'Příprava pro elektrické venkovní žaluzie/rolety'
  }, {
    label: 'Elektro',
    value: 'Schneider Asfora (bílá), UTP v každé místnosti'
  }, {
    label: 'Videotelefon',
    value: 'Videx — domovní dorozumívací systém'
  }]
}, {
  title: 'Akustika a povrchy',
  items: [{
    label: 'Příčky',
    value: 'Fermacell (až 65 dB neprůzvučnost)'
  }, {
    label: 'Podlahy',
    value: 'Minerální vata pro snížení kročejového hluku'
  }, {
    label: 'Zdivo',
    value: 'Jemný štuk Hasit 160'
  }, {
    label: 'Stropy',
    value: 'Zavěšený SDK podhled s akustickou vatou'
  }]
}];
export function StandardsCatalog() {
  const sectionRef = useRef<HTMLDivElement>(null);
  const isInView = useInView(sectionRef, {
    once: true,
    margin: '-80px'
  });
  return <section id="standards" ref={sectionRef} className="w-full bg-villa-dark py-24 md:py-32 px-6 md:px-10 transition-colors duration-500" aria-label="Katalog standardů" data-id="element-160">
      <div className="max-w-6xl mx-auto" data-id="element-161">
        <motion.p initial={{
        opacity: 0,
        y: 16
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.7,
        ease: 'easeOut'
      }} className="text-villa-gold text-[12px] tracking-[0.3em] uppercase font-inter font-light mb-6" data-id="element-162">
          Vybavení
        </motion.p>

        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.7,
        delay: 0.1,
        ease: 'easeOut'
      }} className="font-playfair text-villa-text text-3xl md:text-4xl lg:text-5xl font-medium mb-16 leading-tight" data-id="element-163">
          Katalog standardů
        </motion.h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-x-12 gap-y-16" data-id="element-164">
          {standards.map((category, idx) => <motion.div key={category.title} initial={{
          opacity: 0,
          y: 24
        }} animate={isInView ? {
          opacity: 1,
          y: 0
        } : {}} transition={{
          duration: 0.7,
          delay: 0.2 + idx * 0.1,
          ease: 'easeOut'
        }} data-id="element-165">
              <h3 className="font-playfair text-villa-gold text-2xl font-medium mb-6 border-b border-[var(--color-border-subtle)] pb-4" data-id="element-166">
                {category.title}
              </h3>
              <ul className="space-y-4" data-id="element-167">
                {category.items.map((item, i) => <li key={i} className="flex items-start gap-4" data-id="element-168">
                    <CheckIcon className="w-5 h-5 text-villa-gold/70 mt-0.5 flex-shrink-0" strokeWidth={1.5} data-id="element-169" />
                    <div data-id="element-170">
                      <span className="font-inter text-villa-text text-sm font-medium block mb-1" data-id="element-171">
                        {item.label}
                      </span>
                      <span className="font-inter text-villa-text/60 text-sm font-light leading-relaxed block" data-id="element-172">
                        {item.value}
                      </span>
                    </div>
                  </li>)}
              </ul>
            </motion.div>)}
        </div>
      </div>
    </section>;
}